import { useState, useEffect } from "react";
import SelectBox from "../../../utils/components/SelectBox";

const Conditions = ({ translate, defaultValue, conditions = [], value, onChange }) => {
  const [condition, setCondition] = useState(value || defaultValue);

  const defaultConditions = [
    { name: translate("forms.conditions.equal") , value: "equal"},
    { name: translate("forms.conditions.not_qual") , value: "not_qual"},
    { name: translate("forms.conditions.contains") , value: "contains"},
    { name: translate("forms.conditions.starts_with") , value: "starts_with"},
    { name: translate("forms.conditions.ends_with") , value: "ends_with"},
    { name: translate("forms.conditions.does_not_contain") , value: "does_not_contain"},
    { name: translate("forms.conditions.does_not_starts_with") , value: "does_not_starts_with"},
    { name: translate("forms.conditions.does_not_ends_with") , value: "does_not_ends_with"},
    // date
    { name: translate("forms.conditions.today") , value: "today"},
    { name: translate("forms.conditions.this_week") , value: "this_week"},
    { name: translate("forms.conditions.this_month") , value: "this_month"},
    { name: translate("forms.conditions.before") , value: "before"},
    { name: translate("forms.conditions.after") , value: "after"},
    { name: translate("forms.conditions.in_between") , value: "in_between"},
  ];

  // filter by conditions values
  let items = [...defaultConditions, ...conditions];

  if (conditions.length) {
    items = items.filter((item) => conditions.includes(item.value));
  } else {
    items = defaultConditions;
  }

  const filteredItems = items;

  useEffect(() => {
    if (value !== undefined) {
      setCondition(value);
    }
  }, [value]);

  return (
        <SelectBox
          placeholder={items.find((item) => item.value === condition)?.name}
          options={filteredItems.map((item) => ({
            value: item.value,
            label: item.name,
          }))}
          className="w-100"
          value={condition}
          onChange={(item) => {setCondition(item.value); onChange(item.value)}}
          isClearable={true}
        />
  );
};

export default Conditions;
